import { CampaignDurationBadge } from "./campaign-duration-badge";
import type { CampaignForImage } from "./campaign-for-image";
import { Skeleton } from "../ui/skeleton";
import { Typography } from "../ui/typography";
import { cn } from "@/lib/utils";
import { motion } from "motion/react";
import { useImageUrl } from "@/hooks/use-image-url";
import { useTranslation } from "react-i18next";
import { campaignDisplayTitle } from "@/utils/campaign-helpers";

export type { CampaignForImage } from "./campaign-for-image";

export const CampaignImage = ({
  campaign,
  hideTitle = false,
  darkenImage = false,
  hideDuration = false,
  className,
}: {
  campaign: CampaignForImage;
  hideTitle?: boolean;
  darkenImage?: boolean;
  hideDuration?: boolean;
  className?: string;
}) => {
  const { t } = useTranslation();
  const title = campaignDisplayTitle(campaign, t);
  const imageSrc = useImageUrl(campaign.image);

  return (
    <div
      className={cn(
        "relative aspect-campaignImage w-full overflow-hidden rounded-t-md",
        className
      )}
    >
      {!imageSrc && (
        <Skeleton className="absolute inset-0 h-full w-full rounded-md" />
      )}
      {imageSrc && (
        <motion.img
          src={imageSrc}
          alt={title}
          className="absolute inset-0 h-full w-full object-cover select-none"
          style={{
            filter: darkenImage ? "grayscale(100%)" : "none",
          }}
        />
      )}
      {darkenImage && (
        <div
          className="absolute inset-0 z-10"
          style={{
            background:
              "radial-gradient(circle, color-mix(in srgb, var(--background) 50%, transparent) 0%, var(--background) 100%)",
          }}
        />
      )}
      {!hideTitle && (
        <div className="absolute top-0 left-0 z-20 max-w-[85%] rounded-br-md bg-background/70 px-2 py-1">
          <Typography tag="h6" className="truncate leading-normal">
            {title}
          </Typography>
        </div>
      )}

      {!hideDuration && <CampaignDurationBadge campaign={campaign} />}
    </div>
  );
};
